/**
 * SEPA (Single Euro Payments Area) country codes
 * List of countries supporting SEPA payment method
 * Used for payment method validation
 */

/** SEPA country configuration */
export interface SepaCountry {
  country_code: string
}

export const sepaCountries: readonly SepaCountry[] = [
  { country_code: 'AUT' },  // Austria
  { country_code: 'AND' },  // Andorra
  { country_code: 'BEL' },  // Belgium
  { country_code: 'BGR' },  // Bulgaria
  { country_code: 'HRV' },  // Croatia
  { country_code: 'CYP' },  // Cyprus
  { country_code: 'CZE' },  // Czech Republic
  { country_code: 'DNK' },  // Denmark
  { country_code: 'EST' },  // Estonia
  { country_code: 'FIN' },  // Finland
  { country_code: 'FRA' },  // France
  { country_code: 'DEU' },  // Germany
  { country_code: 'GIB' },  // Gibraltar
  { country_code: 'GRC' },  // Greece
  { country_code: 'HUN' },  // Hungary
  { country_code: 'IRL' },  // Ireland
  { country_code: 'ISL' },  // Iceland
  { country_code: 'ITA' },  // Italy
  { country_code: 'LIE' },  // Liechtenstein
  { country_code: 'LVA' },  // Latvia
  { country_code: 'LTU' },  // Lithuania
  { country_code: 'LUX' },  // Luxembourg
  { country_code: 'MCO' },  // Monaco
  { country_code: 'MLT' },  // Malta
  { country_code: 'NLD' },  // Netherlands
  { country_code: 'NOR' },  // Norway
  { country_code: 'POL' },  // Poland
  { country_code: 'PRT' },  // Portugal
  { country_code: 'ROU' },  // Romania
  { country_code: 'SVK' },  // Slovakia
  { country_code: 'SMR' },  // San Marino
  { country_code: 'SVN' },  // Slovenia
  { country_code: 'SWE' },  // Sweden
  { country_code: 'CHE' },  // Switzerland
  { country_code: 'GBR' },  // United Kingdom
  { country_code: 'VAT' },  // Vatican City
  { country_code: 'ESP' },  // Spain
] as const

/** Union type of SEPA country codes */
export type SepaCountryCode = typeof sepaCountries[number]['country_code'] 
// Type: 'AUT' | 'AND' | 'BEL' | 'BGR' | ... (37 values)
